// import { useEffect } from "react";
// import { useDispatch } from "react-redux";
// import { useNavigate, useLocation } from "react-router-dom";
// import {
//   refreshTokenAsync,
//   setAccessToken,
//   setIsAuthenticated,
//   setRefreshToken,
//   setUserData,
// } from "../Redux/Slices/Pages/Auth/LoginSlice";

// function AuthInitializer() {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const location = useLocation();

//   const getTokenFromStorage = () =>
//     sessionStorage.getItem("token") || localStorage.getItem("token");

//   const getRefreshTokenFromStorage = () =>
//     sessionStorage.getItem("refreshToken") || localStorage.getItem("refreshToken");

//   const getUserFromStorage = () => {
//     const sessionUser = sessionStorage.getItem("userData");
//     const localUser = localStorage.getItem("userData");
//     return sessionUser || localUser;
//   };

//   const syncSessionStorage = () => {
//     const token = localStorage.getItem("token");
//     const refreshToken = localStorage.getItem("refreshToken");
//     const userData = localStorage.getItem("userData");

//     if (token) sessionStorage.setItem("token", token);
//     if (refreshToken) sessionStorage.setItem("refreshToken", refreshToken);
//     if (userData) sessionStorage.setItem("userData", userData);
//   };

//   useEffect(() => {
//     const initializeAuth = async () => {
//       syncSessionStorage();

//       const storedUser = getUserFromStorage();
//       const token = getTokenFromStorage();
//       const refreshToken = getRefreshTokenFromStorage();

//       const onLoginOrRoot =
//         location.pathname === "/" || location.pathname === "/login";

//       if (storedUser && token && refreshToken) {
//         dispatch(setIsAuthenticated(true));
//         dispatch(setAccessToken(token));
//         dispatch(setRefreshToken(refreshToken));
//         dispatch(setUserData(JSON.parse(storedUser)));

//         if (location.pathname === "/login") {
//           navigate("/"); // ✅ redirect only if on login page
//         }
//       } else if (!token && refreshToken) {
//         try {
//           await dispatch(refreshTokenAsync()).unwrap();
//           if (onLoginOrRoot) navigate("/");
//         } catch (err) {
//           console.log("Refresh token failed:", err);
//           if (location.pathname !== "/login") {
//             navigate("/login");
//           }
//         }
//       } else {
//         if (location.pathname !== "/login") {
//           navigate("/login");
//         }
//       }
//     };

//     initializeAuth();
//   }, [dispatch, navigate, location]);

//   // ⏰ Refresh token every 9 minutes
//   useEffect(() => {
//     const interval = setInterval(() => {
//       dispatch(refreshTokenAsync());
//     }, 1000 * 60 * 9);
//     return () => clearInterval(interval);
//   }, [dispatch]);

//   return null;
// }

// export default AuthInitializer;
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import {
  refreshTokenAsync,
  setAccessToken,
  setIsAuthenticated,
  setRefreshToken,
  setUserData,
} from "../Redux/Slices/Pages/Auth/LoginSlice";

function AuthInitializer() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const PUBLIC_ROUTES = ["/", "/login", "/register", "/forgot-password"];
  const isPublicRoute = PUBLIC_ROUTES.includes(location.pathname);

  const getTokenFromStorage = () =>
    sessionStorage.getItem("token") || localStorage.getItem("token");

  const getRefreshTokenFromStorage = () =>
    sessionStorage.getItem("refreshToken") || localStorage.getItem("refreshToken");

  const getUserFromStorage = () => {
    const sessionUser = sessionStorage.getItem("userData");
    const localUser = localStorage.getItem("userData");
    return sessionUser || localUser;
  };

  const syncSessionStorage = () => {
    const token = localStorage.getItem("token");
    const refreshToken = localStorage.getItem("refreshToken");
    const userData = localStorage.getItem("userData");

    if (token) sessionStorage.setItem("token", token);
    if (refreshToken) sessionStorage.setItem("refreshToken", refreshToken);
    if (userData) sessionStorage.setItem("userData", userData);
  };

  useEffect(() => {
    const initializeAuth = async () => {
      syncSessionStorage();

      const storedUser = getUserFromStorage();
      const token = getTokenFromStorage();
      const refreshToken = getRefreshTokenFromStorage();

      if (storedUser && token && refreshToken) {
        dispatch(setIsAuthenticated(true));
        dispatch(setAccessToken(token));
        dispatch(setRefreshToken(refreshToken));
        dispatch(setUserData(JSON.parse(storedUser)));

        if (location.pathname === "/login") {
          navigate("/"); // redirect only if user is on login page
        }
      } else if (!token && refreshToken) {
        try {
          await dispatch(refreshTokenAsync()).unwrap();
          if (!isPublicRoute) {
            navigate("/");
          }
        } catch (err) {
          console.log("Refresh token failed:", err);
          if (!isPublicRoute) {
            navigate("/login");
          }
        }
      } else {
        if (!isPublicRoute) {
          navigate("/login");
        }
      }
    };

    initializeAuth();
  }, [dispatch, navigate, location]);

  // Refresh token every 9 minutes
  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(refreshTokenAsync());
    }, 1000 * 60 * 9);
    return () => clearInterval(interval);
  }, [dispatch]);

  return null;
}

export default AuthInitializer;
